// extracted by mini-css-extract-plugin
export var avatarContainer = "_4w-0";
export var avatarTypingWave = "_4w-i";
export var gray = "_4w-f";
export var green = "_4w-c";
export var icon = "_4w-9";
export var image = "_4w-1";
export var lg = "_4w-6";
export var md = "_4w-5";
export var presenceDot = "_4w-b";
export var red = "_4w-d";
export var sm = "_4w-4";
export var status = "_4w-a";
export var typingDot = "_4w-h";
export var typingPill = "_4w-g";
export var xl = "_4w-7";
export var xs = "_4w-3";
export var xxl = "_4w-8";
export var xxs = "_4w-2";
export var yellow = "_4w-e";